import { render, staticRenderFns } from "./CaracteristicDescription.vue?vue&type=template&id=947fab28&scoped=true"
import script from "./CaracteristicDescription.vue?vue&type=script&lang=js"
export * from "./CaracteristicDescription.vue?vue&type=script&lang=js"
import style0 from "./CaracteristicDescription.vue?vue&type=style&index=0&id=947fab28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947fab28",
  null
  
)

export default component.exports